import { Badge, Divider, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';

import { OrderList } from '@app/components/Order/OrderList';
import { Alert } from '@app/components/Shared/Alert';
import { useAppContext } from '@app/hooks/appContext';
import { useOrderAlert } from '@app/hooks/useOrderAlert';
import { useRoleChecker } from '@app/hooks/useRoleChecker';
import { ProductCategory } from '@app/types/catalog';
import { OrderType, OrderTypeKey } from '@app/types/order';

const TABS = [
  {
    label: '来場予約',
    value: OrderType.PROPERTY_VISITOR_RESERVE,
  },
  {
    label: '資料請求',
    value: OrderType.PROPERTY_REQUEST_DOC,
  },
] as const;

export function PropertyIndex() {
  const { checkReadOrder } = useRoleChecker();
  const { count } = useOrderAlert(ProductCategory.PROPERTY);
  const [tab, setTab] = useState<OrderTypeKey>(TABS[0].value);
  const { orderBadge } = useAppContext();

  if (!checkReadOrder()) {
    return <></>;
  }

  return (
    <>
      {!!count && (
        <Stack spacing={1} mb={2.5}>
          <Alert
            color="error"
            value={`ステータス選択がされていない反響が${count}件あります。`}
          />
        </Stack>
      )}
      <Tabs
        value={tab}
        onChange={(e, value) => setTab(value)}
        sx={{
          '.MuiButtonBase-root': {
            overflow: 'unset !important',
          },
          '.MuiTabs-fixed': {
            overflow: 'unset !important',
          },
          overflow: 'unset !important',
        }}
      >
        {TABS.map(({ label, value }, index) => {
          const badgeContent =
            value === OrderType.PROPERTY_REQUEST_DOC
              ? orderBadge.property.request
              : orderBadge.property.visitor;
          return (
            <Tab
              key={index}
              label={
                badgeContent ? (
                  <Badge
                    badgeContent={badgeContent}
                    color="error"
                    max={99}
                    overlap="circular"
                    sx={{
                      '.MuiBadge-badge': {
                        transform: 'scale(1) translate(120%, -90%)',
                      },
                    }}
                  >
                    <Typography variant="h5">{label}</Typography>
                  </Badge>
                ) : (
                  <Typography variant="h5">{label}</Typography>
                )
              }
              value={value}
            />
          );
        })}
      </Tabs>
      <Divider sx={{ mb: 4.5 }} />
      <OrderList
        title={TABS.find((t) => t.value === tab)?.label}
        orderType={tab}
      />
    </>
  );
}
